import axios from 'axios';

import { env } from '@/utils/env.mjs';

type RequestInput = {
  path: string;
  data?: Record<string, unknown>;
};

const request = async ({ path, data = {} }: RequestInput) => {
  const { NEXT_PUBLIC_MYSHANDS_API_ENDPOINT: endpoint } = env;

  const response = await axios({
    data,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    url: `${endpoint}${path}`,
  });

  return response.data;
};

type SignUpInput = {
  email: string;
  password: string;
  lastName: string;
  firstName: string;
  lpName: string;
};

type SignUpOutput =
  | {
      success: true;
    }
  | {
      success: false;
      fieldErrors: Record<
        keyof SignUpInput,
        {
          fieldName: string;
          messages: string[];
          fullMessages: string[];
        }
      >;
    };

export const signUp = (data: SignUpInput): Promise<SignUpOutput> =>
  request({ path: '/sign_up', data });

export const isDiscounted = (): Promise<boolean> =>
  request({ path: '/is_discounted' });
